import StatisticList from './StatisticList'

export default StatisticList
